module.exports = __webpack_public_path__ + "img/bing.3aa2f571.png";